import React from 'react'

export default class Footer extends React.Component{
  handleClickOpen(){
    const { handleModalOpen } = this.props
    handleModalOpen()
  }

  handleClickClose(){
    const { handleModalClose } = this.props
    handleModalClose()
  }

  render(){
    return(
      <div className="footer">
        <p>Copyright© Genesis Healthcare all rights reserved. </p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js